<template>
    <div class="container">
        <div>
            <!-- Dynamically bind the src attribute to the imported image -->
            <img style="height: 48px;" :src="VETimg" alt="VET Image" />
            <div class="termscondition">
                <h3 style="color: black;">លក្ខខណ្ឌក្នុងការអនុវត្តន៍សម្រាប់សំបុត្រ</h3>
                <h3 style="color: black;">គោលការណ៍អនុវត្តចំពោះការធ្វើដំណើរ</h3>
                <!-- <ol>
                    <li class="main_text">ម៉ោងត្រូវមកដល់ស្ថានីយ៍ដើម្បីត្រៀមចេញដំណើរ</li>
                    <ul>
                        <li> អ្នកដំណើរត្រូវមកដល់ស្ថានីយ៍ចេញដំណើរ និងធ្វើការពិនិត្យផ្ទៀងផ្ទាត់សំបុត្រ
                            និងលេខកៅអីជាមួយបុគ្គលិកយ៉ាងតិច ១៥ នាទីមុន ម៉ោងចេញដំណើរ។</li>
                        <li> អ្នកដំណើរដែលមកដល់ស្ថានីយ៍ចេញដំណើរយឺត(ក្រោយម៉ោងចេញដំណើរ)
                            ឬមិនបង្ហាញខ្លួននៅស្ថានីយ៍ក្នុងកាលបរិច្ឆេទ និង ម៉ោងនៃការធ្វើដំណើរ មិនអាចធ្វើការតវ៉ា
                            ឬទាមទារប្តូរសំបុត្រជាប្រាក់វិញបានទេ។ សំបុត្រនឹងផុតសុពលភាពបន្ទាប់ពីរថយន្តចេញ ដំណើរ។</li>
                    </ul>
                    <li class="main_text">គោលការណ៍អនុវត្តចំពោះសំបុត្រធ្វើដំណើរ</li>
                    <ul>
                        <li>សំបុត្រទិញរួច មិនអាចប្តូរជាប្រាក់វិញបានទេ តែអាចស្នើសុំប្រើជា គូប៉ុង (COUPON)
                            សម្រាប់ការធ្វើដំណើរនៅពេលក្រោយ ដោយត្រូវធ្វើការ ស្នើសុំក្នុងរយៈពេល ១២ ម៉ោង មុនម៉ោងចេញដំណើរ។
                        </li>
                        <li> ការសុំទុកចន្លោះជ្រើសម៉ោងពេលក្រោយ (OPEN) សំបុត្រ ឬប្តូរព័ត៌មានធ្វើដំណើរអាចធ្វើបានក្នុងរយៈពេល
                            ១២ ម៉ោងមុន ពេលចេញដំណើរដោយត្រូវធ្វើការទំនាក់ទំនងមកស្ថានីយ៍ចេញដំណើរដោយផ្ទាល់។ គូប៉ុង (COUPON)
                            និងសំបុត្រទុកចន្លោះ ជ្រើសម៉ោងពេលក្រោយ (OPEN) មានសុពលភាព ៣ ខែ រាប់ចាប់ពីថ្ងៃស្នើសុំ
                            និងអាចប្រើប្រាស់បានចំពោះទិសដៅ និងប្រភេទ ឡានដូចគ្នាតែប៉ុណ្ណោះ(យោងតាមសំបុត្រដើម)។</li>
                    </ul>
                    <li class="main_text">គោលការណ៍អនុវត្តចំពោះទារក កូនក្មេង ស្រ្តីមានផ្ទៃពោះ និងជនពិការ</li>
                    <ul>
                        <li> ក្មេងអាយុក្រោម ៣ ឆ្នាំមិនតម្រូវអោយទិញសំបុត្រនោះទេ
                            ប៉ុន្តែត្រូវអង្គុយលើភ្លៅអាណាព្យាបាលដោយមិនត្រូវបង្កការរំខានដល់អ្នក
                            ដំណើរដែលអង្គុយកៅអីជាប់នោះឡើយ។
                            ក្រុមហ៊ុនមិនទទួលខុសត្រូវលើគ្រោះថ្នាក់ដែលអាចកើតមានឡើងលើក្មេងឡើយ។</li>
                        <li> ក្មេងអាយុចាប់ពី ៣ ឆ្នាំឡើង ឬមានកម្ពស់ចាប់ពី ១ម៉ែត្រ
                            ត្រូវទិញសំបុត្រក្នុងតម្លៃពេញចំពោះឡានកៅអីអង្គុយ។</li>
                        <li> ចំពោះឡានគ្រែគេង កូនក្មេងត្រូវទិញសំបុត្រក្នុងតម្លៃពេញ។ ក្មេងអាយុក្រោម ១៥ឆ្នាំ
                            ត្រូវមានអាណាព្យាបាលរួមដំណើរជាមួយ ដើម្បីមើលការខុសត្រូវ។</li>
                        <li> ស្រ្តីមានផ្ទៃពោះលើសពី ២៧សប្តាហ៍ និងជនពិការ
                            គួរតែទទួលបានការអនុញាតិជាមុនពីក្រុមហ៊ុនមុនពេលទិញសំបុត្រ និងធ្វើ ដំណើរ
                            ដើម្បីធានាបាននូវសុវត្ថិភាព។</li>
                    </ul>
                    <li class="main_text">ដំណើរការឆ្លងដែន</li>
                    <ul>
                        <li> ក្រុមហ៊ុនវិរៈ ប៊ុនថាំ មិនទទួលខុសត្រូវលើរាល់ឯកសារចាំបាច់ (VISA) សម្រាប់នីតិវិធីឆ្លងដែននោះទេ
                            វាជាទំនួលខុសត្រូវរបស់អ្នក ដំណើរ ។</li>
                        <li>សំបុត្រទិញរួចមិនអាចប្តូរជាសាច់ប្រាក់បាននោះទេ ក្នុងករណីអ្នកដំណើរមិនអាចឆ្លងដែនបាន
                            នោះសំបុត្រដែលបានទិញរួចនឹងត្រូវ ផុតសុពលភាពក្រោយពេលរថយន្តចេញដំណើរ ។</li>
                    </ul>
                    <li class="main_text">ការកក់សំបុត្រ និងការជ្រើសរើសកៅអី</li>
                    <ul>
                        <li>អ្នកដំណើរអាចធ្វើការកក់សំបុត្រដោយខ្លួនឯងផ្ទាល់ភ្លាមៗតាមជម្រើសដូចខាងក្រោម៖</li>
                        <li>លេខកក់សំបុត្រ 24/7៖ +85581 911 911</li>
                        <li>កម្មវិធីទូរស័ព្ទ(Mobile app): VET Express</li>
                        <li>វេបសាយ: <a href="http://www.vireakbuntham.com/">http://www.vireakbuntham.com/</a></li>
                        <li>ឬនៅគ្រប់សាខាណាមួយរបស់ក្រុមហ៊ុនវិរៈប៊ុនថាំ ។</li>
                    </ul>
                    <li class="main_text">គោលការណ៍អនុវត្តចំពោះអីវ៉ាន់ដែលអនុញ្ញាតិអោយអ្នកដំណើរយកឡើងរថយន្ត</li>
                    <ul>
                        <li>អ្នកដំណើរអាចយកអីវ៉ាន់តាមខ្លួនក្នុងទំងន់មិនលើសពី ២៥ គីឡូក្រាម។</li>
                        <li>អីវ៉ាន់ដែលមានទំហំធំ ឬលើសកំណត់នឹងត្រូវគិតថ្លៃសេវាបន្ថែម
                            យោងតាមតម្លៃសេវាកម្មបញ្ញើអីវ៉ាន់ជាក់ស្តែង។</li>
                    </ul>
                    <li class="main_text">ប្រភេទអីវ៉ាន់ សម្ភារៈ ឬសត្វដែលហាមយកឡើងរថយន្ត</li>
                    <ul>
                        <li>ខាងក្រោមនេះជាប្រភេទអីវ់ាន់ហាមខាត់យកឡើងរថយន្ត៖</li>
                        <li>ប្រភេទម្ហូបអាហារ ឬផ្លែឈើមានក្លិនខ្លាំង (ឧ.ប្រហុក ផ្អក ផ្លែធុរ៉េន...)</li>
                        <li>ប្រភេទសត្វមានជីវិតគ្រប់ប្រភេទ (ឆ្កែ ឆ្មា មាន់ ទា...)</li>
                        <li>អាវុធមានជាតិផ្ទុះគ្រប់ប្រភេទ</li>
                        <li>គ្រឿងញៀនគ្រប់ប្រភេទ ការជក់បារី បារីអេឡិចត្រូនិក និងការប្រើប្រាស់សារធាតុញៀនក្នុងរថយន្ត</li>
                        <li>ទំនិញខុសច្បាប់</li>
                        <li>វត្ថុងាយឆាបឆេះ គ្រឿងផ្ទុះ ឬសារធាតុបង្កគ្រោះថ្នាក់ផ្សេងៗ</li>
                    </ul>
                    <li class="main_text">ទំនួលខុសត្រូវរបស់អ្នកដំណើរ</li>
                    <ul>
                        <li> អ្នកដំណើរត្រូវទទួលខុសត្រូវលើសុវត្ថិភាព
                            និងការថែទាំទ្រព្យសម្បត្តិផ្ទាល់ខ្លួនដោយខ្លួនឯងផ្ទាល់។</li>
                        <li>ក្រុមហ៊ុនមិនទទួលខុសត្រូវចំពោះការបាក់បែក ឬបាត់បង់ទ្រព្យសម្បត្តិឯកជនរបស់អ្នកដំណើរឡើយ។</li>
                    </ul>
                    <li class="main_text">គោលការណ៍អនុវត្តចំពោះសារជាតិស្រវឹង</li>
                    <ul>
                        <li>ការយកគ្រឿងស្រវឹងចូលរថយន្ត ឬទទួលទានគ្រឿងស្រវឹងលើរថយន្តត្រូវបានហាមឃាត់។</li>
                        <li>ក្រុមហ៊ុនរក្សាសិទ្ធិក្នុងការជម្រាបអោយចុះពីរថយន្តចំពោះអ្នកដំណើរដែលស្រវឹង
                            អ្នកដំណើរដែលគ្មានអនាម័យ ឬអ្នកដំណើរដែល
                            មានឥរិយាបថមិនសមរម្យបង្កការរំខានដល់អ្នកដំណើរផ្សេងទៀតក្នុងរថយន្តដោយមិនអាចទាមទារប្រាក់ថ្លៃសំបុត្រវិញបានឡើយ។
                        </li>
                    </ul>
                    <li class="main_text">សំបុត្រអេឡិចត្រូនិក (E-Ticket Delivery)</li>
                    <ul>
                        <li> ក្រោយពេលទូទាត់ប្រាក់រួច ប្រសិនបើលោកអ្នកមិនទទួលបាន E-Ticket តាមរយៈអ៊ីម៉ែល
                            សូមលោកអ្នកចុចលើប៊ូតុង “ Resend Email” ។</li>
                        <li>សូមធ្វើការពិនិត្យ Spam inbox ដើម្បីស្វែងរកសំបុត្រដែលក្រុមហ៊ុនផ្ញើចូល
                            ករណីមិនឃើញក្នុងប្រអប់សារ។</li>
                        <li> ករណីលោកអ្នកនៅតែមិនអាចរកឃើញ ឬ ទទួលបាន E-Ticket សូមទាក់ទងសេវាអតិថិជនតាមរយៈ <a
                                href="tel:+85581911911">+85581911911</a> ឬ <a
                                href="mailto:support@vireakbuntham.com">support@vireakbuntham.com</a> ។</li>
                        <li>សូមបញ្ជាក់ថាអ្នកដំណើរមិនអាចស្នើសុំប្រាក់ត្រឡប់(Refund) វិញបាននោះទេ ប្រសិនបើមិនទទួលបានសំបុត្រ
                            E-ticket។</li>
                    </ul>
                </ol> -->
                <div v-for="item in termsKh" :key="item.id" class="mb-6 space-y-4">
                    <div class="mb-2 main_text" style=""> {{ item.id }}. {{ item.title }} </div>
                    <div class="pl-8">
                        <template v-if="item.id === 14">
                            <div v-for="(content, index) in item.contents" :key="index"
                                class="mb-2 text-gray-700 leading-7">
                                {{ content }}
                            </div>
                        </template>
                        <template v-else>
                            <template v-for="(content, index) in item.contents">
                                <li v-if="typeof content === 'string'" :key="'str-' + index"
                                    class="mb-2 text-gray-700 leading-7">
                                    {{ content }}
                                </li>
                                <ul v-else-if="content && content.sub" :key="'sub-' + index"
                                    style="list-style-type: disc;" class="px-8">
                                    <li v-for="(subContent, subIndex) in content.sub" :key="subIndex"
                                        class="mb-2 text-gray-700 leading-7">
                                        {{ subContent }}
                                    </li>
                                </ul>
                            </template>
                        </template>
                    </div>
                </div>
            </div>

        </div>
        <div>
            <img style="height: 48px;" :src="VETimg" alt="VET Image" />
            <div class="termscondition">
                <h3 style="color: black;">Terms & Conditions for Tickets</h3>
                <h3 style="color: black;">{{ $t('message.checkInBoardingPolicy') }}</h3>
                <ol>
                    <li class="main_text">{{ $t('message.tc1') }}</li>
                    <ul style="list-style-type: disc;" class="pl-8">
                        <li>{{ $t('message.tcd1') }}</li>
                        <li>{{ $t('message.tcd2') }}</li>
                        <li>{{ $t('message.tcd3') }}</li>
                        <li>{{ $t('message.tcd4') }}</li>
                    </ul>
                    <li class="main_text">{{ $t('message.tc2') }}</li>
                    <ul style="list-style-type: disc;" class="pl-8">
                        <li>{{ $t('message.tcd5') }}</li>
                        <li>{{ $t('message.tcd6') }}</li>
                        <li>{{ $t('message.tcd7') }}</li>
                        <li>{{ $t('message.tcd8') }}</li>
                        <li>{{ $t('message.tcd9') }}</li>
                    </ul>
                    <li class="main_text">{{ $t('message.tc3') }}</li>
                    <ul style="list-style-type: disc;" class="pl-8">
                        <li>{{ $t('message.tcd10') }}</li>
                        <li>{{ $t('message.tcd11') }}</li>
                        <li>{{ $t('message.tcd12') }}</li>
                        <li>{{ $t('message.tcd13') }}</li>
                        <li>{{ $t('message.tcd14') }}</li>
                    </ul>
                    <li class="main_text">{{ $t('message.tc4') }}</li>
                    <ul style="list-style-type: disc;" class="pl-8">
                        <li>{{ $t('message.tcd15') }}</li>
                        <li>{{ $t('message.tcd16') }}</li>
                        <li>{{ $t('message.tcd17') }}</li>
                    </ul>
                    <li class="main_text">{{ $t('message.tc5') }}</li>
                    <ul style="list-style-type: disc;" class="pl-8">
                        <li>{{ $t('message.tcd18') }}</li>
                        <li>{{ $t('message.tcd19') }}</li>
                        <li>{{ $t('message.tcd20') }}</li>
                        <li>{{ $t('message.tcd21') }}</li>
                    </ul>
                    <li class="main_text">{{ $t('message.tc6') }}</li>
                    <ul style="list-style-type: disc;" class="pl-8">
                        <li>{{ $t('message.tcd22') }}</li>
                        <ul style="list-style-type: disc;">
                            <li>{{ $t('message.tcd23') }}</li>
                            <li>{{ $t('message.tcd24') }}</li>
                            <li>{{ $t('message.tcd25') }}</li>
                            <li>{{ $t('message.tcd26') }}</li>
                        </ul>
                        <li>{{ $t('message.tcd27') }}</li>
                        <li>{{ $t('message.tcd28') }}</li>
                        <li>{{ $t('message.tcd29') }}</li>
                    </ul>
                    <li class="main_text">{{ $t('message.tc7') }}</li>
                    <ul style="list-style-type: disc;" class="pl-8">
                        <li>{{ $t('message.tcd30') }}</li>
                        <li>{{ $t('message.tcd31') }}</li>
                        <li>{{ $t('message.tcd32') }}</li>
                        <li>{{ $t('message.tcd33') }}</li>
                    </ul>
                    <li class="main_text">{{ $t('message.tc8') }}</li>
                    <ul style="list-style-type: disc;" class="pl-8">
                        <li>{{ $t('message.tcd34') }}</li>
                        <ul style="list-style-type: disc;">
                            <li>{{ $t('message.tcd35') }}</li>
                            <li>{{ $t('message.tcd36') }}</li>
                            <li>{{ $t('message.tcd37') }}</li>
                            <li>{{ $t('message.tcd38') }}</li>
                            <li>{{ $t('message.tcd39') }}</li>
                            <li>{{ $t('message.tcd40') }}</li>
                            <li>{{ $t('message.tcd41') }}</li>
                        </ul>
                        <li>{{ $t('message.tcd42') }}</li>
                    </ul>
                    <li class="main_text">{{ $t('message.tc9') }}</li>
                    <ul style="list-style-type: disc;" class="pl-8">
                        <li>{{ $t('message.tcd43') }}</li>
                        <li>{{ $t('message.tcd44') }}</li>
                        <li>{{ $t('message.tcd45') }}</li>
                    </ul>
                    <li class="main_text">{{ $t('message.tc10') }}</li>
                    <ul style="list-style-type: disc;" class="pl-8">
                        <li>{{ $t('message.tcd46') }}</li>
                        <li>{{ $t('message.tcd47') }}</li>
                        <li>{{ $t('message.tcd48') }}</li>
                        <li>{{ $t('message.tcd49') }}</li>
                    </ul>
                    <li class="main_text">{{ $t('message.tc11') }}</li>
                    <ul style="list-style-type: disc;" class="pl-8">
                        <li>{{ $t('message.tcd50') }}</li>
                        <li>{{ $t('message.tcd51') }}</li>
                        <li>{{ $t('message.tcd52') }}</li>
                    </ul>
                    <li class="main_text">{{ $t('message.tc12') }}</li>
                    <ul style="list-style-type: disc;" class="pl-8">
                        <li>{{ $t('message.tcd53') }}</li>
                        <li>{{ $t('message.tcd54') }}</li>
                        <li>{{ $t('message.tcd55') }}</li>
                        <li>{{ $t('message.tcd56') }}</li>
                        <li>{{ $t('message.tcd57') }}</li>
                    </ul>
                    <li class="main_text">{{ $t('message.tc13') }}</li>
                    <ul style="list-style-type: disc;" class="pl-8">
                        <li>{{ $t('message.tcd58') }}</li>
                        <li>{{ $t('message.tcd59') }}</li>
                        <li>{{ $t('message.tcd60') }}</li>
                        <li>{{ $t('message.tcd61') }}</li>
                    </ul>
                    <li class="main_text">{{ $t('message.tc14') }}</li>
                    <ul class="pl-8">
                        <p style="font-size: 14px;font-weight: 400;">{{ $t('message.tcd62') }}</p>
                    </ul>
                </ol>
            </div>

        </div>
        <div>
            <img style="height: 48px;" :src="VETimg" alt="VET image">
            <div class="termscondition">
                <h3 style="color: black;">车票条款与条件</h3>
                <h3 style="color: black;">值机与登车政策</h3>
                <div v-for="item in termsCH" :key="item.id" class="mb-6 space-y-4">
                    <div class="mb-2"> {{ item.id }}. {{ item.title }} </div>
                    <div class="pl-8">
                        <template v-if="item.id === 14">
                            <div v-for="(content, index) in item.contents" :key="index"
                                class="mb-2 text-gray-700 leading-7">
                                {{ content }}
                            </div>
                        </template>
                        <template v-else>
                            <template v-for="(content, index) in item.contents">
                                <li v-if="typeof content === 'string'" :key="'str-' + index"
                                    class="mb-2 text-gray-700 leading-7">
                                    {{ content }}
                                </li>
                                <ul v-else-if="content && content.sub" :key="'sub-' + index"
                                    style="list-style-type: disc;" class="px-8">
                                    <li v-for="(subContent, subIndex) in content.sub" :key="subIndex"
                                        class="mb-2 text-gray-700 leading-7">
                                        {{ subContent }}
                                    </li>
                                </ul>
                            </template>
                        </template>
                    </div>
                </div>
                <!-- <ol>
                    <li class="main_text">到达时间</li>
                    <ul class="px-8">
                        <li>乘客必须在预定出发时间前15分钟到达登车点办理登车手续。</li>
                        <li> 乘客要确保提前或按时到达登车站。如果未能按时到达预定时间或者迟到，恕不退款而已经购买的车票将在巴士出发后失效。</li>
                    </ul>
                    <li class="main_text">票务政策</li>
                    <ul>
                        <li>已购买的车票不可退款，但可以转换为未来行程的购票券。</li>
                        <li>购票券退款可在出发时间前的最多12小时内进行处理。优惠券的有效期为三个月，且仅可用于同一路线和车辆类型的重新预订一次。</li>
                    </ul>
                    <li class="main_text">婴儿、儿童、孕妇和残疾人政策</li>
                    <ul>
                        <li>3岁以下的婴儿无需购票，但须由成人陪同并坐在成人大腿上并不打扰邻座乘客。对于婴儿在旅行期间发生的任何伤害，公司不承担任何责任。</li>
                        <li>3岁及以上或身高超过1米的儿童需全价购买自己的座位。</li>
                        <li>对于卧铺巴士，婴儿需要购买全价票。</li>
                        <li> 27周以上的孕妇或者残疾人士在购票前需提前告知并获得公司的批准，以确保自身安全。本公司对旅行期间发生的任何并发症不承担责任。</li>
                    </ul>
                    <li class="main_text">过境政策</li>
                    <ul>
                        <li>对于跨境行程，Vireak Buntham Express Travel不对签证入境负责。</li>
                        <li>如果在边境遇到移民拒绝入境的情况下，乘客将不会有资格获得车票退款。</li>
                    </ul>
                    <li class="main_text">预订与座位选择</li>
                    <ul>
                        <li>乘客可以通过以下方式选择自己喜欢的座位并购买实时车票：</li>
                        <li>预订热线：+855 81 911 911</li>
                        <li>手机App：VET Express</li>
                        <li><a href="http://www.vireakbuntham.com/">网站：www.vireakbuntham.com</a></li>
                        <li>任何VET车站</li>
                    </ul>
                    <li class="main_text">行李政策</li>
                    <ul>
                        <li>乘客最多可带 25 公斤的行李和一件随身包。</li>
                        <li>超重行李将根据当地配送费用收取额外费用。</li>
                    </ul>
                    <li class="main_text">禁带物品</li>
                    <ul>
                        <li>以下物品严格禁止携带上车：</li>
                        <li>强烈气味的食物（如榴莲）</li>
                        <li>宠物及其他活体动物</li>
                        <li>各类枪支 </li>
                        <li>各种类型的毒品、吸烟、电子烟及药物滥用行为</li>
                        <li>走私或非法物品</li>
                        <li>危险、易燃或爆炸物品</li>
                    </ul>
                    <li class="main_text">乘客责任</li>
                    <ul>
                        <li>乘客对个人物品和贵重物品的安全负责</li>
                        <li>VET 对任何个人物品的丢失或损坏不承担责任。</li>
                    </ul>
                    <li class="main_text">酒精政策</li>
                    <ul>
                        <li>禁止将酒精带入车辆或在车内饮酒。</li>
                        <li>公司保留在乘客醉酒、不卫生或表现出不当行为、扰乱其他乘客的情况下，要求其下车的权利，并且此类乘客将无权要求退还车票。</li>
                    </ul>
                    <li class="main_text">电子票发放</li>
                    <ul>
                        <li>如果您在完成付款后未收到电子票，请点击“重新发送邮件”按钮。</li>
                        <li>请检查您的垃圾邮件箱。</li>
                        <li>如果仍未收到电子票，请通过电子邮件联系 support@vireakbuntham.com 或拨打我们的热线电话 (+855) 81 911 911。</li>
                        <li>如果未收到电子票，乘客将无法申请车票退款。</li>
                    </ul>
                </ol> -->
            </div>
        </div>
    </div>
</template>

<script>
import VETimg from '@/assets/icon_bars/Picture1.jpg';

const termsKh = [
    {
        id: 1,
        title: 'ម៉ោងត្រូវមកដល់ស្ថានីយ៍ដើម្បីត្រៀមចេញដំណើរ',
        contents: [
            'អ្នកដំណើរត្រូវមកដល់ទីតាំងឡើងរថយន្តយ៉ាងហោចណាស់ ៣០ នាទី មុនម៉ោងចេញដំណើរដែលបានកំណត់ ដើម្បីធ្វើការពិនិត្យសំបុត្រ និងឡើងរថយន្ត។',
            'ក្រុមហ៊ុនរក្សាសិទ្ធិក្នុងការបដិសេធមិនអនុញ្ញាតឱ្យឡើងរថយន្តចំពោះអ្នកដំណើរដែលមកដល់ក្រោយម៉ោងចេញដំណើរដែលបានកំណត់។ សំបុត្ររបស់អ្នកដំណើរដែលមកយឺត ឬមិនបង្ហាញខ្លួន នឹងត្រូវចាត់ទុកថាបានប្រើប្រាស់រួច ហើយមិនអាចសងប្រាក់វិញបានឡើយ។',
            'អ្នកដំណើរមានទំនួលខុសត្រូវក្នុងការធានាថាបានឡើងរថយន្តនៅស្ថានីយ៍ ម៉ោងចេញដំណើរ និងរថយន្តត្រឹមត្រូវ។',
            'ក្រុមហ៊ុនរក្សាសិទ្ធិក្នុងការចេញដំណើរតាមម៉ោងកំណត់ ដោយមិនចាំបាច់ជូនដំណឹងបន្ថែមឡើយ។'
        ]
    },
    {
        id: 2,
        title: 'គោលការណ៍អនុវត្តចំពោះសុពលភាព ការលុបចោល និងប្តូរកាលបរិច្ឆេទសំបុត្រធ្វើដំណើរ',
        contents: [
            'សំបុត្រដែលបានទិញ និងបញ្ជាក់រួច មិនអាចសងជាប្រាក់វិញបានឡើយ។',
            'អ្នកដំណើរអាចស្នើសុំប្តូរសំបុត្រទៅជាគូប៉ុង ឬប្តូរកាលបរិច្ឆេទធ្វើដំណើរ យ៉ាងហោចណាស់ ១២ ម៉ោងមុនម៉ោងចេញដំណើរ អាស្រ័យលើភាពទំនេរនៃកៅអី និងស្របតាមគោលការណ៍ និងលក្ខខណ្ឌដែលក្រុមហ៊ុនបានកំណត់។',
            'គូប៉ុងមានសុពលភាពរយៈពេល ៣ ខែ គិតចាប់ពីថ្ងៃស្នើសុំ។',
            'គូប៉ុងអាចស្នើសុំ និងប្រើប្រាស់បានតែម្តងប៉ុណ្ណោះ។',
            'គូប៉ុងត្រូវប្រើសម្រាប់ទិសដៅ និងប្រភេទរថយន្តដូចគ្នានឹងសំបុត្រដើម។',
            'គូប៉ុងមិនអាចសងប្រាក់វិញ ឬផ្ទេរទៅអ្នកដទៃបានឡើយ។',
            'មិនអនុញ្ញាតឱ្យលុបចោល សងប្រាក់វិញ ប្តូរជាគូប៉ុង ឬប្តូរកាលបរិច្ឆេទធ្វើដំណើរ ក្រោយម៉ោងចេញដំណើរឡើយ។'
        ]
    },
    {
        id: 3,
        title: 'គោលការណ៍អនុវត្តចំពោះទារក កូនក្មេង ស្រ្តីមានផ្ទៃពោះ និងជនពិការ',
        contents: [
            'ក្មេងអាយុក្រោម ៣ ឆ្នាំមិនតម្រូវអោយទិញសំបុត្រនោះទេ ប៉ុន្តែត្រូវអង្គុយលើភ្លៅអាណាព្យាបាលដោយមិនត្រូវបង្កការរំខានដល់អ្នក ដំណើរដែលអង្គុយកៅអីជាប់នោះឡើយ។ ក្រុមហ៊ុនមិនទទួលខុសត្រូវលើគ្រោះថ្នាក់ដែលអាចកើតមានឡើងកំឡុងពេលធ្វើដំណើរលើក្មេងឡើយ។',
            'ក្មេងអាយុចាប់ពី ៣ ឆ្នាំឡើង ឬមានកម្ពស់ចាប់ពី ១ម៉ែត្រ ត្រូវទិញសំបុត្រក្នុងតម្លៃពេញសម្រាប់កៅអីអង្គុយផ្ទាល់ខ្លួន។',
            'សម្រាប់រថយន្តគ្រែគេង អ្នកដំណើរទាំងអស់ រួមទាំងទារក ត្រូវប្រើគ្រែផ្ទាល់ខ្លួន ដូច្នេះតម្រូវឱ្យទិញសំបុត្រពេញតម្លៃ។',
            'ស្រ្តីមានផ្ទៃពោះលើសពី ២៧សប្តាហ៍ និងជនពិការ គួរតែទទួលបានការអនុញាតិជាមុនពីក្រុមហ៊ុនមុនពេលទិញសំបុត្រ និងធ្វើដំណើរដើម្បីធានាបាននូវសុវត្ថិភាព។ ក្រុមហ៊ុននឹងមិនទទួលខុសត្រូវចំពោះបញ្ហាដែលអាចកើតមានឡើងកំឡុងពេលធ្វើដំណើរឡើយ។',
            'ក្រុមហ៊ុនរក្សាសិទ្ធិក្នុងការបដិសេធការដឹកជញ្ជូន ប្រសិនបើស្ថានភាពសុខភាព ឬស្ថានភាពរាងកាយរបស់អ្នកដំណើរ អាចបង្កហានិភ័យដល់សុវត្ថិភាពរបស់ខ្លួន អ្នកដំណើរផ្សេងទៀត បុគ្គលិក ឬប្រតិបត្តិការរបស់ក្រុមហ៊ុន។'
        ]
    },
    {
        id: 4,
        title: 'ការឆ្លងដែន និងអន្តោប្រវេសន៍',
        contents: [
            'អ្នកដំណើរមានទំនួលខុសត្រូវផ្ទាល់ខ្លួនក្នុងការអនុវត្តតាមលក្ខខណ្ឌអន្តោប្រវេសន៍ ទិដ្ឋាការ គយ លិខិតឆ្លងដែន និងលក្ខខណ្ឌចូលប្រទេសគោលដៅណាមួយ។',
            'ក្រុមហ៊ុនមិនទទួលខុសត្រូវចំពោះការអនុម័ត ឬការបដិសេធទិដ្ឋាការ ការបដិសេធចូលប្រទេសដោយអន្តោប្រវេសន៍ ការបញ្ជូនត្រឡប់ បញ្ហាសុពលភាពលិខិតឆ្លងដែន ការផាកពិន័យពីគយ ឬការរឹតបន្តឹងការចូលប្រទេសដែលកំណត់ដោយអាជ្ញាធរ។',
            'អ្នកដំណើរដែលត្រូវបានអាជ្ញាធរអន្តោប្រវេសន៍បដិសេធមិនអនុញ្ញាតឱ្យចូលប្រទេស មិនមានសិទ្ធិស្នើសុំសងប្រាក់វិញ ឬទាមទារសំណងណាមួយឡើយ។'
        ]
    },
    {
        id: 5,
        title: 'ការផ្លាស់ប្តូរកាលវិភាគ ការពន្យារពេល និងករណីប្រធានសក',
        contents: [
            'ម៉ោងចេញដំណើរ និងមកដល់គឺជាការប៉ាន់ស្មានប៉ុណ្ណោះ ហើយអាចរងផលប៉ះពាល់ដោយសារចរាចរណ៍ អាកាសធាតុ ស្ថានភាពផ្លូវ នីតិវិធីព្រំដែន ការរឹតបន្តឹងរបស់រដ្ឋាភិបាល បញ្ហាបច្ចេកទេស ឬកត្តាប្រតិបត្តិការផ្សេងៗដែលស្ថិតក្រៅការគ្រប់គ្រងរបស់ក្រុមហ៊ុន។',
            'ក្រុមហ៊ុនរក្សាសិទ្ធិក្នុងការពន្យារពេលចេញដំណើរ ផ្លាស់ប្តូរកាលវិភាគ ផ្លាស់ប្តូរទីតាំងឡើង ឬចុះ ផ្លាស់ប្តូររថយន្ត ឬប្តូរកៅអី នៅពេលចាំបាច់សម្រាប់ប្រតិបត្តិការ។',
            'ក្រុមហ៊ុនមិនទទួលខុសត្រូវចំពោះការខាតបង់ដោយប្រយោល ការខកខានការតភ្ជាប់ដំណើរ ការខាតបង់អាជីវកម្ម ចំណាយសណ្ឋាគារ ឬការខូចខាតផ្សេងៗដែលបណ្តាលមកពីការពន្យារពេល ឬការផ្លាស់ប្តូរប្រតិបត្តិការ។',
            'ក្នុងករណីប្រធានសក្តិ រួមមាន ប៉ុន្តែមិនកំណត់ត្រឹមគ្រោះធម្មជាតិ គ្រោះថ្នាក់ ភាពចលាចលនយោបាយ ការបិទព្រំដែន បទបញ្ជារដ្ឋាភិបាល កូដកម្ម ជំងឺរាតត្បាត ឬអាកាសធាតុធ្ងន់ធ្ងរ ក្រុមហ៊ុនអាចផ្អាក ឬលុបចោលសេវាកម្មដោយមិនទទួលខុសត្រូវឡើយ។'
        ]
    },
    {
        id: 6,
        title: 'ការកក់សំបុត្រ និងការជ្រើសរើសកៅអី',
        contents: [
            'អ្នកដំណើរអាចធ្វើការកក់សំបុត្រដោយខ្លួនឯងផ្ទាល់ភ្លាមៗតាមជម្រើសដូចខាងក្រោម៖',
            {
                sub: [
                    'លេខកក់សំបុត្រ 24/7៖ +85581 911 911',
                    'កម្មវិធីទូរស័ព្ទ(Mobile app): VET Express',
                    'វេបសាយ www.vireakbuntham.com',
                    'ឬនៅគ្រប់សាខាណាមួយរបស់ក្រុមហ៊ុនវិរៈប៊ុនថាំ ។'
                ]
            },
            'សំបុត្រធ្វើដំណើរអាចទិញបានគ្រប់ពេលមុនម៉ោងចេញដំណើរ។',
            'អ្នកដំណើរអាចជ្រើសរើសកៅអីដែលពេញចិត្តនៅពេលកក់សំបុត្រ ប៉ុន្តែការកំណត់កៅអីអាចត្រូវបានកែប្រែតាមតម្រូវការប្រតិបត្តិការនៅពេលចាំាច់។',
            'ក្រុមហ៊ុនរក្សាសិទ្ធិក្នុងការប្តូរកៅអី ឬផ្លាស់ប្តូររៀបចំរថយន្ត ដោយមិនចាំាច់ជូនដំណឹងជាមុន សម្រាប់ហេតុផលប្រតិបត្តិការ សុវត្ថិភាព ឬការថែទាំរថយន្ត។'
        ]
    },
    {
        id: 7,
        title: 'គោលការណ៍អនុវត្តចំពោះអីវ៉ាន់ដែលអនុញ្ញាតិអោយអ្នកដំណើរយកឡើងរថយន',
        contents: [
            'អ្នកដំណើរអាចយកអីវ៉ាន់តាមខ្លួនក្នុងទំងន់មិនលើសពី ២៥ គីឡូក្រាម។',
            'អីវ៉ាន់ដែលមានទំហំធំ ឬលើសកំណត់នឹងត្រូវគិតថ្លៃសេវាបន្ថែម យោងតាមតម្លៃសេវាកម្មបញ្ញើអីវ៉ាន់ជាក់ស្តែង។',
            'អ្នកដំណើរត្រូវធានាថាអីវ៉ាន់ទាំងអស់ត្រូវបានភ្ជាប់ស្លាកទទួលអីវ៉ាន់របស់ក្រុមហ៊ុនត្រឹមត្រូវ និងរក្សាទុកឱ្យមានសុវត្ថិភាព។',
            'ក្រុមហ៊ុនរក្សាសិទ្ធិក្នុងការត្រួតពិនិត្យអីវ៉ាន់សម្រាប់គោលបំណងសុវត្ថិភាព និងសន្តិសុខ។'
        ]
    },
    {
        id: 8,
        title: 'ការហាមឃាត់យកឡើងរថយន្ត',
        contents: [
            'ខាងក្រោមនេះជាប្រភេទអីវ់ាន់ហាមឃាត់ក្នុងការយកឡើងរថយន្ត៖',
            {
                sub: [
                    'ប្រភេទម្ហូបអាហារ ឬផ្លែឈើមានក្លិនខ្លាំង (ឧ.ប្រហុក ផ្អក ផ្លែធុរ៉េន...)',
                    'ប្រភេទសត្វមានជីវិតគ្រប់ប្រភេទ (ឆ្កែ ឆ្មា មាន់ ទា...)',
                    'អាវុធមានជាតិផ្ទុះគ្រប់ប្រភេទ',
                    'នីកូទីន',
                    'គ្រឿងញៀនគ្រប់ប្រភេទ ការជក់បារី បារីអេឡិចត្រូនិក និងការប្រើប្រាស់សារធាតុញៀនក្នុងរថយន្ត ',
                    'ទំនិញខុសច្បាប់',
                    'វត្ថុងាយឆាបឆេះ គ្រឿងផ្ទុះ ឬសារធាតុបង្កគ្រោះថ្នាក់ផ្សេងៗ',
                ]
            },
            'ក្រុមហ៊ុនរក្សាសិទ្ធិក្នុងការបដិសេធការដឹកជញ្ជូនវត្ថុហាមឃាត់ និងរាយការណ៍ការបំពានទៅអាជ្ញាធរពាក់ព័ន្ធ។'
        ]
    },
    {
        id: 9,
        title: 'ទំនួលខុសត្រូវរបស់អ្នកដំណើរ',
        contents: [
            'អ្នកដំណើរមានទំនួលខុសត្រូវក្នុងការធានាថាព័ត៌មានទាំងអស់ដែលបានផ្តល់ក្នុងពេលកក់សំបុត្រ រួមមាន ឈ្មោះអ្នកដំណើរ ព័ត៌មានទំនាក់ទំនង ព័ត៌មានលិខិតឆ្លងដែន កាលបរិច្ឆេទធ្វើដំណើរ និងគោលដៅ មានភាពត្រឹមត្រូវ និងពេញលេញ។',
            'អ្នកដំណើរត្រូវទទួលខុសត្រូវលើសុវត្ថិភាព និងការថែទាំទ្រព្យសម្បត្តិផ្ទាល់ខ្លួនដោយខ្លួនឯងផ្ទាល់។',
            'ក្រុមហ៊ុនមិនទទួលខុសត្រូវចំពោះការបាត់បង់ ការខូចខាត ឬការបាក់បែកនៃទ្រព្យសម្បត្តិផ្ទាល់ខ្លួន វត្ថុមានតម្លៃ សាច់ប្រាក់ ឧបករណ៍អេឡិចត្រូនិក ឬសម្ភារៈងាយបាក់បែករបស់អ្នកដំណើរឡើយ។'
        ]
    },
    {
        id: 10,
        title: 'អីវ៉ាន់បាត់ ខូច ឬគ្មានអ្នកទទួ',
        contents: [
            'អ្នកដំណើរមានទំនួលខុសត្រូវក្នុងការថែរក្សាវត្ថុមានតម្លៃផ្ទាល់ខ្លួន រួមមាន សាច់ប្រាក់ គ្រឿងអលង្ការ ឧបករណ៍អេឡិចត្រូនិក ឯកសារ និងសម្ភារៈងាយបាក់បែក។',
            'ក្រុមហ៊ុនមិនទទួលខុសត្រូវចំពោះការបាត់បង់វត្ថុមានតម្លៃ ការខូចខាតសម្ភារៈងាយបាក់បែក អីវ៉ាន់ដែលទុកចោលដោយគ្មានការត្រួតពិនិត្យ ឬការខូចខាតតិចតួចដែលកើតឡើងក្នុងអំឡុងពេលដឹកជញ្ជូនឡើយ។',
            'ការទាមទារណាមួយពាក់ព័ន្ធនឹងអីវ៉ាន់ ត្រូវរាយការណ៍ភ្លាមៗនៅពេលមកដល់ និងត្រូវមានស្លាកទទួលអីវ៉ាន់ក្រុមហ៊ុនត្រឹមត្រូវ ឬភស្តុតាងបញ្ជាក់កម្មសិទ្ធិ។',
            'អីវ៉ាន់ដែលគ្មានអ្នកទទួល អាចត្រូវបានចាត់ចែង ឬបោះបង់ចោល ស្របតាមគោលការណ៍របស់ក្រុមហ៊ុន បន្ទាប់ពីផុតរយៈពេលរក្សាទុកដែលច្បាប់អនុញ្ញាត។'
        ]
    },
    {
        id: 11,
        title: 'អាកប្បកិរិយា និងសុវត្ថិភាពអ្នកដំណើរ',
        contents: [
            'អ្នកដំណើរត្រូវប្រព្រឹត្តខ្លួនដោយគោរព និងអនុវត្តតាមការណែនាំរបស់អ្នកបើកបរ បុគ្គលិកលើរថយន្ត និងតំណាងក្រុមហ៊ុន។`',
            'ក្រុមហ៊ុនរក្សាសិទ្ធិក្នុងការបដិសេធមិនអនុញ្ញាតឱ្យឡើងរថយន្ត ឬអញ្ជើញអ្នកដំណើរចេញដោយមិនសងប្រាក់វិញ ប្រសិនបើអ្នកដំណើរស្ថិតក្នុងស្ថានភាពស្រវឹង បង្ហាញអាកប្បកិរិយាប៉ះពាល់ ប្រមាថ បង្កភាពរំខាន បង្កហានិភ័យដល់សុវត្ថិភាព បំផ្លាញទ្រព្យសម្បត្តិក្រុមហ៊ុន បង្កភាពមិនស្រួលដល់អ្នកដំណើរផ្សេងទៀត ឬរំលោភលើគោលការណ៍របស់ក្រុមហ៊ុន ឬច្បាប់មូលដ្ឋាន។',
            'អ្នកដំណើរអាចត្រូវទទួលខុសត្រូវផ្នែកហិរញ្ញវត្ថុចំពោះការខូចខាតដែលបង្កឡើងដល់ទ្រព្យសម្បត្តិក្រុមហ៊ុន ឬភាគីទីបី។`'
        ]
    },
    {
        id: 12,
        title: 'សំបុត្រអេឡិចត្រូនិក (E-Ticket Delivery) ',
        contents: [
            'អ្នកដំណើរត្រូវផ្តល់អាសយដ្ឋានអ៉ីម៉ែល និងព័ត៌មានទំនាក់ទំនងដែលត្រឹមត្រូវនៅពេលធ្វើការកក់សំបុត្រ។`',
            'E-Ticket នឹងត្រូវចាត់ទុកថាបានផ្ញើជោគជ័យ បន្ទាប់ពីប្រព័ន្ធរបស់ក្រុមហ៊ុនបានបង្កើត និងផ្ញើរួច។`',
            'ក្រោយពេលទូទាត់ប្រាក់រួច ប្រសិនបើលោកអ្នកមិនទទួលបាន E-Ticket តាមរយៈអ៉ីម៉ែល សូមពិនិត្យប្រអប់ Spam/Junk Mail ចុចប៊ូតុង “ផ្ញើអ៉ីម៉ែលម្តងទៀត (Resend Email)” ឬទាក់ទងសេវាអតិថិជនភ្លាមៗមុនពេលចេញដំណើរ។`',
            'ការមិនទទួលបាន ឬមិនអាចបង្ហាញ E-Ticket ដោយសារការបញ្ចូលអ៊ីមែលមិនត្រឹមត្រូវ បញ្ហាអ៉ីនធឺណិត Spam Filter បញ្ហាឧបករណ៍ ឬការមិនទាក់ទងសេវាអតិថិជន មិនអាចចាត់ទុកជាមូលហេតុសម្រាប់សងប្រាក់វិញបានឡើយ។`',
            'ក្នុងករណីដែលលោកអ្នកនៅតែមិនទទួលបាន E-Ticket សូមទាក់ទងសេវាអតិថិជនតាមរយៈអ៉ីម៉ែល support@vireakbuntham.com ឬលេខទូរស័ព្ទ (+855) 81 911 911។`'
        ]
    },
    {
        id: 13,
        title: 'ការកំណត់ការទទួលខុសត្រូវ',
        contents: [
            'ក្នុងវិសាលភាពអតិបរមាដែលច្បាប់អនុញ្ញាត ការទទួលខុសត្រូវរបស់ក្រុមហ៊ុនចំពោះការទាមទារណាមួយដែលកើតចេញពីសេវាកម្មដឹកជញ្ជូន នឹងកំណត់ត្រឹមតម្លៃសំបុត្រដែលបានទិញប៉ុណ្ណោះ។`',
            'ក្រុមហ៊ុនមិនទទួលខុសត្រូវចំពោះការខាតបង់ដោយប្រយោល ការខូចខាតចៃដន្យ ការខូចខាតពិសេស ការពិន័យ ឬការខូចខាតជាបន្តបន្ទាប់ រួមមាន ការបាត់បង់ចំណូល ឱកាសអាជីវកម្ម ចំណាយស្នាក់នៅ ភាពតានតឹងផ្លូវអារម្មណ៍ ឬការខកខានការតភ្ជាប់ដំណើរ។`',
            'ក្រុមហ៊ុនរក្សាទុកកំណត់ត្រាប្រតិបត្តិការ រួមទាំងការថតវីដេអូពីកាមេរ៉ាលើរថយន្តក្នុងរយៈពេលកំណត់ ស្របតាមគោលការណ៍ផ្ទៃក្នុងរបស់ក្រុមហ៊ុន។ អ្នកដំណើរត្រូវបានណែនាំឱ្យរាយការណ៍ការតវ៉ា បណ្តឹង ឬការទាមទារណាមួយពាក់ព័ន្ធនឹងសេវាកម្ម ក្នុងរយៈពេល ៣០ ថ្ងៃ គិតចាប់ពីថ្ងៃធ្វើដំណើរ។ ក្រុមហ៊ុនមិនទទួលខុសត្រូវចំពោះការមិនអាចផ្តល់កំណត់ត្រាប្រតិបត្តិការបាន បន្ទាប់ពីផុតរយៈពេលរក្សាទុកដែលបានកំណត់។`',
            'ការជំទាស់ការទូទាត់ ឬការស្នើសុំ Chargeback ណាមួយ ត្រូវមានភស្តុតាងត្រឹមត្រូវគាំទ្រ។ ក្រុមហ៊ុនរក្សាសិទ្ធិក្នុងការផ្តល់កំណត់ត្រាកក់សំបុត្រ កំណត់ត្រាឡើងរថយន្ត កំណត់ត្រាតាមដានរថយន្ត ប្រវត្តិទំនាក់ទំនង និងភស្តុតាងប្រតិបត្តិការផ្សេងៗ ទៅកាន់ស្ថាប័នទូទាត់ ស្ថាប័នហិរញ្ញវត្ថុ ភ្នាក់ងារ OTA ឬអាជ្ញាធរពាក់ព័ន្ធ ដើម្បីប្រឆាំងនឹងការទាមទារ ឬការជំទាស់ដែលមិនមានមូលដ្ឋានត្រឹមត្រូវ។`'
        ]
    },
    {
        id: 14,
        title: 'ការយល់ព្រមលក្ខខណ្ឌ',
        contents: [
            'តាមរយៈការទិញ ការកក់ ឬការប្រើប្រាស់សេវាកម្ម VET Express/VET AirBus អ្នកដំណើរត្រូវបានចាត់ទុកថាបានអាន យល់ និងយល់ព្រមតាមលក្ខខណ្ឌទាំងនេះ។'
        ]
    }
]
const termsCH = [
    {
        id: 1,
        title: '到达时间',
        contents: [
            '乘客须至少于预定出发时间前30分钟到达指定登车地点办理值机及登车手续。',
            '本公司有权拒绝迟于预定出发时间到达的乘客登车。迟到或未出现乘客的车票将被视为已使用，且不可退款。',
            '乘客须自行确认并确保于正确的车站、出发时间及车辆登车。',
            '本公司有权严格按照预定出发时间发车，恕不另行通知。'
        ]
    },
    {
        id: 2,
        title: '车票有效期、取消及改期政策',
        contents: [
            '所有已确认购买的车票均不可退款。',
            '乘客可于出发前至少12小时申请将车票转换为旅行优惠券或改期，但须视座位情况及公司相关条款与条件而定。',
            '优惠券自申请日起有效期最长为3个月。',
            '优惠券仅可申请及使用一次。',
            '优惠券仅适用于与原车票相同的路线及车辆类别。',
            '优惠券不可退款及不可转让。',
            '发车时间后，将不允许取消、退款、转换优惠券或改期。'
        ]
    },
    {
        id: 3,
        title: '婴儿、儿童、孕妇和残疾人政策',
        contents: [
            '3岁以下的婴儿无需购票，但须由成人陪同并坐在成人大腿上并不打扰邻座乘客。对于婴儿在旅行期间发生的任何伤害，公司不承担任何责任。',
            '3岁及以上或身高超过1米的儿童需全价购买自己的座位。',
            '对于卧铺巴士，所有乘客（包括婴儿）均须使用独立床位，因此需购买全价车票。',
            '27周以上的孕妇或者残疾人士在购票前需提前告知并获得公司的批准，以确保自身安全。本公司对旅行期间发生的任何并发症不承担责任。',
            '如乘客的健康或身体状况可能对其本人、其他乘客、工作人员或运营安全造成风险，本公司有权拒绝其乘车。'
        ]
    },
    {
        id: 4,
        title: '边境与移民责任',
        contents: [
            '乘客须自行负责遵守目的地国家有关移民、签证、海关、护照及入境要求的所有规定。',
            '本公司不对签证获批或被拒、移民局拒绝入境、遣返、护照有效性问题、海关罚款或有关当局实施的入境限制承担任何责任。',
            '被移民局或相关 authorities 拒绝入境的乘客，将无权获得退款或任何赔偿。'
        ]
    },
    {
        id: 5,
        title: '班次变更、延误及不可抗力',
        contents: [
            '出发及到达时间仅为预计时间，可能因交通状况、天气、道路情况、边境程序、政府限制、技术问题或其他超出公司控制范围的运营情况而受到影响。',
            '本公司有权在运营需要情况下延迟发车、调整班次、更改上下车地点、更换车辆或重新安排座位。',
            '对于因延误或运营调整所造成的间接损失、错过转乘、商业损失、酒店费用或其他连带损失，本公司概不承担责任。',
            '如发生不可抗力事件，包括但不限于自然灾害、事故、政治动荡、边境关闭、政府命令、罢工、流行病或恶劣天气情况，本公司有权暂停或取消服务且不承担任何责任。'
        ]
    },
    {
        id: 6,
        title: '预订与座位选择',
        contents: [
            '乘客可以通过以下方式选择自己喜欢的座位并购买实时车票：',
            {
                sub: [
                    '预订热线：+855 81 911 911',
                    '手机App：VET Express',
                    '网站：www.vireakbuntham.com',
                    '任何VET车站'
                ]
            },
            '车票可以在预定出发时间之前随时购买。',
            '乘客可在预订时选择偏好的座位，但座位安排在必要情况下可能因运营需要而进行调整。',
            '本公司有权因运营、安全或车辆维护原因，在不事先通知的情况下重新安排座位或调整车辆配置。'
        ]
    },
    {
        id: 7,
        title: '行李政策',
        contents: [
            '乘客最多可带 25 公斤的行李和一件随身包。',
            '超重行李将根据当地配送费用收取额外费用。',
            '乘客须确保所有行李均已正确贴附公司行李领取标签并妥善保管。',
            '本公司有权基于安全及安保目的对行李进行检查。'
        ]
    },
    {
        id: 8,
        title: '禁带物品',
        contents: [
            '以下物品严格禁止携带上车：',
            {
                sub: [
                    '强烈气味的食物（如榴莲）',
                    '宠物',
                    '火器',
                    '毒品',
                    '各种类型的毒品、吸烟、电子烟及药物滥用行为',
                    '走私或非法物品',
                    '危险、易燃或爆炸物品'
                ]
            },
            '本公司有权拒绝运输违禁物品，并向有关当局举报相关违规行为。'
        ]
    },
    {
        id: 9,
        title: '乘客责任',
        contents: [
            '乘客须确保所有预订信息，包括乘客姓名、联系方式、护照信息、出行日期及目的地等，均准确无误且完整。',
            '乘客对个人物品和贵重物品的安全负责',
            '本公司不对乘客个人物品、贵重物品、现金、电子设备或易碎物品的遗失、损坏或变质承担任何责任。'
        ]
    },
    {
        id: 10,
        title: '行李遗失、损坏或无人认领',
        contents: [
            '乘客须自行保管个人贵重物品，包括现金、珠宝、电子设备、文件及易碎物品。',
            '本公司不对贵重物品遗失、易碎物品损坏、无人看管物品或运输过程中产生的轻微磨损承担责任。',
            '任何行李索赔必须在抵达后立即提出，并提供有效的行李领取标签或所有权证明。',
            '无人认领的行李在超过法律允许的保管期限后，公司可根据公司政策进行处理或处'
        ]
    },
    {
        id: 11,
        title: '乘客行为与安全',
        contents: [
            '乘客须保持礼貌，并遵守司机、车上工作人员及公司代表所提供的指示。',
            '本公司有权拒绝醉酒、具有攻击性、辱骂性、扰乱秩序、危及安全、损坏公司财产、影响其他乘客，或违反公司政策及当地法律的乘客登车，或要求其下车，且不予退款。',
            '乘客可能需对其造成的公司财产或第三方损失承担经济赔偿责任。'
        ]
    },
    {
        id: 12,
        title: '电子票发放',
        contents: [
            '乘客须在预订时提供有效的电子邮箱地址及联系方式。',
            '一旦电子车票由公司系统生成并发送，即视为成功送达。',
            '如乘客在完成付款后未收到电子车票，请检查垃圾邮件箱、使用“重新发送邮件（Resend Email）”功能，或在出发前立即联系客户服务。',
            '请检查您的垃圾邮件箱。',
            '如仍未收到电子车票，请通过电子邮件 support@vireakbuntham.com 或热线电话 (+855) 81 911 911 联系客户服务。'
        ]
    },
    {
        id: 13,
        title: '责任限制',
        contents: [
            '在适用法律允许的最大范围内，本公司对于因运输服务所产生的任何索赔责任，仅限于已购买车票的价值。',
            '本公司不对任何间接、附带、特殊、惩罚性或后果性损失承担责任，包括收入损失、商业机会损失、住宿费用、精神损害或错过转乘。',
            '本公司根据内部政策在有限期限内保存运营记录，包括车载监控录像。建议乘客在乘车日期起三十（30）天内提出任何与服务相关的投诉、争议或索赔。超过记录保存期限后，如相关运营记录无法提供，本公司不承担任何责任。',
            '任何付款争议或拒付（Chargeback）申请均须提供有效证据支持。本公司有权向支付机构、金融机构、代理商、OTA 或有关当局提供订票记录、登车记录、车辆追踪记录、沟通记录及其他运营证据，以抗辩欺诈性或无依据的索赔。'
        ]
    },
    {
        id: 14,
        title: '接受条条款接受款与条件',
        contents: [
            '通过购买、预订或使用 VET Express/VET AirBus 服务，即表示乘客已阅读、理解并同意本条款与条件。'
        ]
    }
]

export default {
    name: 'TermsConditionTicket',
    data() {
        return {
            VETimg, // Expose the imported image for use in the template,./
            termsKh,
            termsCH

        };
    },


};
</script>

<style>
.main_text {
    font-weight: 600;
    font-size: 14px;
    color: #1E1E1F;
}

.termscondition {
    /* padding: 15px; */

    text-align: justify;
}

.container {
    display: flex;
    flex-wrap: wrap;
    justify-content: space-between;
    align-items: flex-start;
    gap: 20px;
    padding-bottom: 50px;
}

ul li {
    line-height: 26px;
}
</style>
